module.exports = __webpack_public_path__ + "img/fan_error.a814e357.svg";